import { FunctionComponent } from 'react';

import { imageResizer } from 'utils/image';
import { Prefix, uniqueId } from 'utils/uniqueId';

import StyledComponent from './styles';
import { Props } from './types';

const PublicLayoutHeadlineAndImageBox: FunctionComponent<Props> = ({ title, subtitle, image, imageResizeWidth }) => {
    return (
        <StyledComponent className="public-layout-headline-and-image-box">
            <div
                key={uniqueId(Prefix.Image)}
                className="image"
            >
                <img
                    src={imageResizer(image, { width: imageResizeWidth, quality: 90 })}
                    loading="lazy"
                    alt="image box"
                />
                <div className="title">{title}</div>
                <div className="subtitle">{subtitle}</div>
            </div>
        </StyledComponent>
    );
};

export default PublicLayoutHeadlineAndImageBox;
